import React, { Fragment, useEffect, useRef, useState } from 'react'
import foodOfferImg from "../../../assets/food/foodofferimg.png"
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import FbHeader from '../component/FbHeader';
import QRCode from 'react-qr-code';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import { settings } from 'eslint-plugin-import/config/react';
import redeemedIcon from "../../../assets/food/redeemed.webp"
import chooseYourOfferPvr from "../../../assets/food/choose-your-offer-pvr.svg"
import chooseYourOfferInox from "../../../assets/food/choose-your-offer-inox.svg"
import activateOfferToSeeQrPvr from "../../../assets/food/activate-offer-to-see-qr-pvr.svg"
import activateOfferToSeeQrInox from "../../../assets/food/activate-offer-to-see-qr-inox.svg"
import howQrCodePvr from "../../../assets/food/show-qr-code-pvr.svg"
import howQrCodeInox from "../../../assets/food/show-qr-code-inox.svg"
import closeIcon from "../../../assets/food/close.svg";
import redeemedSucess from "../../../assets/food/redeemed-sucess.gif";
import CountdownTimer from '../component/CountdownTimer';
import SweetAlertUtility from '../component/SweetAlertUtility';
import * as appConstants from "../../../constants/index";
import axios from 'axios';
import { formatDateWithOrdinal, formatExpiryDate } from '../component/commonFunction';
import { Modal } from 'react-bootstrap';
import OfferactivatedSkeleton from "src/skeletons/OfferactivatedSkeleton";
import { format } from 'date-fns';
// import QRCode from 'react-qr-code';

const OfferActivated = () => {
    const isManualSlideRef = useRef(false);
    const navigate = useNavigate();
    const location = useLocation();
    const redeemedVouchersRef = useRef([]);
    const sliderRef = useRef(null);

    const [alertDetails, setAlertDetails] = useState({ show: false, type: "", title: "", message: "" });
    const [loading, setLoading] = useState(true);
    const [showHowItsWork, setShowHowItsWork] = useState(false);
    const [isClosingHowItsWork, setIsClosingHowItsWork] = useState(false);
    const [isClosingTnC, setIsClosingTnC] = useState(false);
    const [isClosingRedeem, setIsClosingRedeem] = useState(false);
    const [showTnC, setShowTnC] = useState(false);
    const [showRedeem, setShowRedeem] = useState(false);
    const [showFullPageQR, setShowFullPageQR] = useState(false);
    const [offerCardData, setOfferCardData] = useState(null);
    const [redeemActivated, setRedeemActivated] = useState(null);
    const [tncData, setTncData] = useState(null);
    const [howItsWork, setHowItsWork] = useState(null);
    const [remainingTime, setRemainingTime] = useState({ minutes: 0, seconds: 0 });
    const [count, setCount] = useState(1);
    const [activeSlide, setActiveSlide] = useState(0);
    const [redeemTimestamps, setRedeemTimestamps] = useState({});

    // const [showTimer, setShowTimer] = useState(false);
    const [isClosingTimer, setIsClosingTimer] = useState(false);

    // const [isManualSlide, setIsManualSlide] = useState(false);
    // const [isRed, setIsRed] = useState(false);

    const FoodActivated = JSON.parse(localStorage.getItem("FoodActivated")) || [];
    const AuthToken = sessionStorage.getItem("token") || "";
    const theme = localStorage.getItem("theme");
    const theatreId = JSON.parse(localStorage.getItem("TheatreId"));
    const pageName = localStorage.getItem("pageName");
    const orders = JSON.parse(localStorage.getItem("prepareMultiOrderStatus")) || [];
    const FoodListTimerId = JSON.parse(localStorage.getItem("FoodListTimerId"));
    const cartOffers = JSON.parse(localStorage.getItem("cartOffers")) || [];
    const timerId = JSON.parse(localStorage.getItem("timerId")) || [];
    const redTimer = JSON.parse(localStorage.getItem("redTimer") * 60) || [];

    localStorage.setItem("promBanner", false);

    const storeAllOfferData = JSON.parse(localStorage.getItem("storeAllOfferData") || "[]");
    const filteredLength = FoodActivated.length > 0
        ? FoodActivated.filter(item => item.theatreId === theatreId)?.length
        : pageName === "FBOptionPage"
            ? storeAllOfferData?.length
            : storeAllOfferData.filter(item => item.theatreId === theatreId)?.length;

    const qrFilterlength = FoodListTimerId?.length || filteredLength;
    // Show QR if there's only 1 or none
    useEffect(() => {
        setShowFullPageQR(filteredLength <= 1);
    }, []);

    useEffect(() => {
        if (FoodListTimerId) {
            setShowFullPageQR(true);
            fetchOffers(FoodListTimerId);
        } else {
            fetchOffers(storeAllOfferData);
        }
    }, []);

    useEffect(() => {
        const activeTimer = storeAllOfferData.find(timer =>
            timer?.expiryDate && new Date(timer.expiryDate).getTime() > Date.now()
        );
        if (activeTimer) {
            fetchRedeem();
            const interval = setInterval(fetchRedeem, 4000);
            return () => clearInterval(interval);
        }
    }, []);

    const handleTnC = (id, type) => {
        setTncData(offerCardData.find(item => item.voucherNo === id));
        if (type === "howtowork") {
            setShowHowItsWork(true);
            setIsClosingHowItsWork(true);
        } else {
            setShowTnC(true);
            setIsClosingTnC(true);
        }
    };

    const handleHideHowItsWork = () => {
        setIsClosingHowItsWork(true);
        setTimeout(() => {
            setIsClosingHowItsWork(false);
            setShowHowItsWork(false);
        }, 50);
    };

    const handleHideTnC = () => {
        setIsClosingTnC(true);
        setTimeout(() => {
            setIsClosingTnC(false);
            setShowTnC(false);
        }, 50);
    };

    const handleHideRedeem = () => {
        setIsClosingRedeem(true);
        setTimeout(() => {
            setShowRedeem(false);
            setIsClosingRedeem(false);
        }, 50);
    };

    // const handleHide = () => {
    //     setIsClosingTimer(false);
    //     console.log("false02")
    //     setShowTimer(false);
    // };

    const fetchOffers = async (storedOffers) => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${appConstants.base_url}v1/jito/on-the-fly-offers?ccode=${theatreId}`,
                {
                    headers: {
                        Authorization: `Bearer ${AuthToken}`,
                        "Content-Type": "application/json",
                        chain: theme === "inoxTheme" ? "INOX" : "PVR",
                        appVersion: appConstants.av,
                        platform: appConstants.pt,
                    },
                }
            );

            if (response.data.result.toLowerCase() === "success") {
                const listData = response?.data?.output?.onTheFlyOffers || [];

                const mergedData = FoodActivated.length > 0
                    ? FoodActivated?.filter(item => item.theatreId === theatreId)?.map(offer => {
                        const matched = listData.find(item => item.voucherNo === offer.voucherNo);
                        return {
                            ...offer,
                            ...(matched || {}),
                            expiryDate: formatExpiryDate(offer.expiryDate || matched?.expDate),
                            activatedDate: formatExpiryDate(offer.activatedDate)
                        };
                    })
                    : pageName === "FBOptionPage"
                        ? storedOffers?.map(offer => {
                            const matched = listData.find(item => item.voucherNo === offer.voucherNo);
                            return {
                                ...offer,
                                ...(matched || {}),
                                expiryDate: formatExpiryDate(offer.expiryDate || matched?.expDate),
                                activatedDate: formatExpiryDate(offer.activatedDate)
                            };
                        })
                        : storedOffers?.filter(item => item.theatreId === theatreId)?.map(offer => {
                            const matched = listData.find(item => item.voucherNo === offer.voucherNo);
                            return {
                                ...offer,
                                ...(matched || {}),
                                expiryDate: formatExpiryDate(offer.expiryDate || matched?.expDate),
                                activatedDate: formatExpiryDate(offer.activatedDate)
                            };
                        });

                setOfferCardData(mergedData);
                // Redeem Content Update 
                const foodOffer = JSON.parse(localStorage.getItem("foodoffers") || "{}");
                if (foodOffer && foodOffer.voucherId && foodOffer.theatreId) {
                    const matched = listData.find(item => item.voucherId === foodOffer.voucherId && theatreId === foodOffer.theatreId) || {};
                    localStorage.setItem("foodoffers", JSON.stringify(matched));
                }

                const currentTime = Date.now();
                const validOffers = storedOffers?.filter(item => {
                    const expiry = new Date(item.expiryDate).getTime();
                    return expiry > currentTime && item.voucherStatus !== "Redeemed";
                });

                const newUniqueOffers = pageName === "FBOptionPage" ? mergedData.filter(
                    item => !storeAllOfferData.some(existing => existing.voucherId === item.voucherId)
                ) : mergedData.filter(
                    item => !storeAllOfferData.some(existing => existing.voucherId === item.voucherId && existing.theatreId === theatreId)
                );

                if (newUniqueOffers.length > 0) {
                    const updatedStore = [...storeAllOfferData, ...newUniqueOffers];
                    localStorage.setItem("storeAllOfferData", JSON.stringify(updatedStore));
                }

                const filteredCart = cartOffers.filter(
                    item => !mergedData.some(active => active.voucherId === item.voucherId && item.theatreId === theatreId)
                );

                localStorage.setItem("cartOffers", JSON.stringify(filteredCart));
            } else {
                sweetAlertError(response?.data?.msg || "Failed to fetch offers.");
            }
        } catch (err) {
            console.error("Error fetching offers:", err);
            sweetAlertError("Something went wrong while fetching offers.");
        } finally {
            setLoading(false);
        }
    };

    const fetchRedeem = async () => {
        if (!storeAllOfferData?.length) return;

        const voucherNos = storeAllOfferData.map(item => item.voucherNo);

        try {
            const response = await axios.post(
                `${appConstants.base_url}v1/jito/on-the-fly-offers-redeem-status`,
                { vouNo: voucherNos },
                {
                    headers: {
                        Authorization: `Bearer ${AuthToken}`,
                        chain: theme === "inoxTheme" ? "INOX" : "PVR",
                        appVersion: appConstants.av,
                        platform: appConstants.pt,
                    }
                }
            );

            if (response.data.result.toLowerCase() === "success") {
                const redeemData = response.data.output?.onTheFlyOffers || [];
                console.log('Redeem API response:', redeemData);

                // Handle newly redeemed vouchers
                const newlyRedeemed = redeemData.filter(item =>
                    item.voucherStatus === "Redeemed" &&
                    !redeemedVouchersRef.current.includes(item.voucherNo)
                );

                if (newlyRedeemed.length > 0) {
                    setShowRedeem(true);
                    redeemedVouchersRef.current = [
                        ...redeemedVouchersRef.current,
                        ...newlyRedeemed.map(item => item.voucherNo)
                    ];
                }

                // Update storeAllOfferData in localStorage
                const filtered = storeAllOfferData.filter(item =>
                    !redeemData.some(redeemed =>
                        redeemed.voucherNo === item.voucherNo &&
                        redeemed.voucherStatus.toLowerCase() === "redeemed"
                    )
                );
                localStorage.setItem("storeAllOfferData", JSON.stringify(filtered));
                setRedeemActivated(redeemData);

                // Update prepareMultiOrderStatus in localStorage
                const updatedOrders = JSON.parse(localStorage.getItem("prepareMultiOrderStatus")) || [];

                const updatedWithRedeemStatus = updatedOrders.map(order => {
                    if (!order.activateVoucher) return order;

                    const updatedActivateVoucher = order.activateVoucher.map(voucher => {

                        const redeemedItem = redeemData.find(redeemed =>
                            String(redeemed.voucherNo) === String(voucher.voucherNo)
                        );


                        return {
                            ...voucher,
                            isRedeem: redeemedItem ?
                                redeemedItem.voucherStatus.toLowerCase() === "redeemed" :
                                voucher.isRedeem || false
                        };
                    });

                    return { ...order, activateVoucher: updatedActivateVoucher };
                });

                // console.log('Updated orders:', updatedWithRedeemStatus);
                localStorage.setItem("prepareMultiOrderStatus", JSON.stringify(updatedWithRedeemStatus));
            }
        } catch (err) {
            console.error("Redeem fetch failed:", err);
        }
    };

    const initializeTimer = (storeAllOfferData, setRemainingTime) => {
        if (!storeAllOfferData || storeAllOfferData.length === 0) return;

        // Find the latest voucher (assuming it's the first one or needs sorting)
        const latestVoucher = storeAllOfferData.reduce((latest, current) => {
            return (!latest || new Date(current.expiryDate) > new Date(latest.expiryDate))
                ? current
                : latest;
        }, null);

        if (!latestVoucher || !latestVoucher.voucherId || !latestVoucher.activatedDate || !latestVoucher.expiryDate) {
            console.error("Invalid or incomplete voucher data");
            return;
        }

        const { voucherNo, activatedDate, expiryDate, theatreId } = latestVoucher;
        const targetTime = new Date(expiryDate).getTime();
        const currentTime = Date.now();

        // Cleanup any existing interval for this voucher
        if (window.timerIntervals && window.timerIntervals[voucherNo]) {
            clearInterval(window.timerIntervals[voucherNo]);
            delete window.timerIntervals[voucherNo];
        }

        // Initialize order storage
        let orders = JSON.parse(localStorage.getItem("prepareMultiOrderStatus")) || [];
        let mainOrder = orders.find(order => order.deliveryMode === "ONSEAT" && !order.foodItems) || null;

        // Create new order if none exists
        if (!mainOrder) {
            mainOrder = {
                en_bid: voucherNo,
                bookingId: null,
                targetTime,
                orderTaken: new Date(activatedDate).getTime(),
                currentStatus: "Offer expires in",
                storeAllOfferData: true,
                deliveryMode: "ONSEAT",
                foodItems: null,
                activateVoucher: []
            };
            orders.push(mainOrder);
        }

        // Update voucher list, ensuring no duplicates and proper theatre filtering
        const existingVoucherNos = new Set(mainOrder.activateVoucher.map(v => v.voucherNo));

        const newVouchers = storeAllOfferData
            .filter(item =>
                !item.foodItems &&
                !existingVoucherNos.has(item.voucherNo) &&
                item.theatreId === theatreId &&
                item.voucherStatus !== "Redeemed"
            )
            .map(item => ({
                voucherId: item.voucherId,
                voucherNo: item.voucherNo,
                activatedDate: item.activatedDate,
                expiryDate: item.expiryDate,
                theatreId: item.theatreId,
                isRedeem: item.voucherStatus
            }));

        if (newVouchers.length > 0) {
            mainOrder.activateVoucher.push(...newVouchers);
            localStorage.setItem("prepareMultiOrderStatus", JSON.stringify(orders));
        }

        // Timer logic
        const updateTimer = () => {
            const now = Date.now();
            const timeRemaining = Math.max(0, targetTime - now);

            if (timeRemaining <= 0) {
                // Timer expired - cleanup
                setRemainingTime?.({ minutes: 0, seconds: 0 });

                // Remove expired voucher from storage
                const updatedOrders = orders.map(order => ({
                    ...order,
                    activateVoucher: order.activateVoucher.filter(v => v.voucherNo !== voucherNo && v.voucherStatus !== "Redeemed")
                })).filter(order =>
                    order.activateVoucher.length > 0 ||
                    order.foodItems // Keep orders with food items
                );

                localStorage.setItem("prepareMultiOrderStatus", JSON.stringify(updatedOrders));

                if (window.timerIntervals?.[voucherNo]) {
                    clearInterval(window.timerIntervals[voucherNo]);
                    delete window.timerIntervals[voucherNo];
                }
            } else {
                // Update remaining time
                const minutes = Math.floor(timeRemaining / (1000 * 60));
                const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
                setRemainingTime?.({ minutes, seconds });
            }
        };

        // Initialize timer
        updateTimer();
        const timerInterval = setInterval(updateTimer, 1000);

        // Store interval reference
        window.timerIntervals = window.timerIntervals || {};
        window.timerIntervals[voucherNo] = timerInterval;

        // Return cleanup function
        return () => {
            if (window.timerIntervals?.[voucherNo]) {
                clearInterval(window.timerIntervals[voucherNo]);
                delete window.timerIntervals[voucherNo];
            }
        };
    };

    useEffect(() => {
        if (offerCardData?.length > 0) {
            const cleanup = initializeTimer(offerCardData, setRemainingTime);
            return () => {
                if (typeof cleanup === "function") cleanup();
            };
        }
    }, [offerCardData]);

    // const handleDismiss = async () => {
    //     setShowTimer(false);

    //     const pageName = localStorage.getItem("pageName");
    //     const bckUrl = pageName === "FBOptionPage" ? "/?tab=food" : pageName === "offercart" ? "/foodcart" : "/food-Vouchers-at-boxoffice";
    //     navigate(bckUrl);
    //     // navigate("/food-Vouchers-at-boxoffice");
    // };

    // useEffect(() => {
    //     const cleanupOrders = () => {
    //         const currentTime = Date.now();
    //         const orders = JSON.parse(localStorage.getItem("prepareMultiOrderStatus")) || [];

    //         const filteredOrders = orders.map(order => {
    //             const { targetTime, activateVoucher, foodItems } = order;

    //             if (foodItems && foodItems.length > 0) {
    //                 return order;
    //             }

    //             if (currentTime >= targetTime) return null;

    //             const remainingVouchers = (activateVoucher || []).filter(v => v.isRedeem !== true);

    //             if (remainingVouchers.length === 0) return null;

    //             return {
    //                 ...order,
    //                 activateVoucher: remainingVouchers
    //             };
    //         }).filter(Boolean); // Remove nulls

    //         localStorage.setItem("prepareMultiOrderStatus", JSON.stringify(filteredOrders));
    //     };

    //     cleanupOrders();

    //     const cleanupInterval = setInterval(cleanupOrders, 60000);
    //     return () => clearInterval(cleanupInterval);
    // }, []);
    useEffect(() => {
        const cleanupOrders = () => {
            try {
                const currentTime = Date.now();
                const orders = JSON.parse(localStorage.getItem("prepareMultiOrderStatus")) || [];

                const filteredOrders = orders.map(order => {
                    if (!order) return null;

                    const { targetTime, activateVoucher = [], foodItems = [] } = order;

                    // Keep orders with food items
                    if (foodItems && foodItems.length > 0) {
                        return order;
                    }

                    // Remove expired orders
                    if (targetTime && currentTime >= targetTime) {
                        return null;
                    }

                    // Filter out redeemed vouchers (both isRedeem true and voucherStatus "Redeemed")
                    const remainingVouchers = activateVoucher.filter(v => { return v?.isRedeem !== true && v?.voucherStatus?.toLowerCase() !== "redeemed" });

                    // Remove orders with no remaining valid vouchers
                    if (remainingVouchers.length === 0) {
                        return null;
                    }

                    return {
                        ...order,
                        activateVoucher: remainingVouchers
                    };
                })
                    .filter(Boolean); // Remove null entries

                localStorage.setItem("prepareMultiOrderStatus", JSON.stringify(filteredOrders));
            } catch (error) {
                console.error("Error cleaning up orders:", error);
                // Optionally clear corrupted data
                localStorage.removeItem("prepareMultiOrderStatus");
            }
        };

        // Initial cleanup
        cleanupOrders();

        // Set up periodic cleanup
        const cleanupInterval = setInterval(cleanupOrders, 60000);

        // Cleanup function to clear interval
        return () => {
            clearInterval(cleanupInterval);
        };
    }, []);
    // **Fixed useEffect for Counting for Modal Redirect**
    useEffect(() => {
        if (showRedeem) {
            setCount(1);
            const interval = setInterval(() => {
                setCount((prev) => {
                    if (prev <= 1) {
                        clearInterval(interval);
                        if (storeAllOfferData?.length > 0) {
                            setShowRedeem(false);
                            setIsClosingRedeem(false);
                        } else {
                            navigate("/food-Vouchers-at-boxoffice")
                            // setShowRedeem(false);
                            // setIsClosingRedeem(false);
                        }
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [showRedeem, isClosingRedeem]);

    const settings = {
        centerMode: false,
        centerPadding: '50px',
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        beforeChange: () => {
            isManualSlideRef.current = true;
        },
        afterChange: (current) => {
            setActiveSlide(current);
            setTimeout(() => {
                isManualSlideRef.current = false;
            }, 800); // Give time for transition
        }
    };

    const sweetAlertError = (msg) => {
        setAlertDetails({
            show: true,
            type: "error",
            title: "Error!",
            message: msg,
        });
    };

    const hideAlert = () => {
        setAlertDetails({ show: false });
        navigate("/?tab=food")
    };

    const getLastActivatedVoucher = (offers) => {
        if (!offers || offers.length === 0) return null;

        return offers?.reduce((latest, current) => {
            return new Date(current.activatedDate) > new Date(latest.activatedDate)
                ? current
                : latest;
        });
    };

    const calculateDuration = (voucher) => {
        if (!voucher) return 0;
        const startTime = new Date(voucher.activatedDate).getTime();
        const endTime = new Date(voucher.expiryDate).getTime();
        return Math.max((endTime - startTime) / 1000, 0);
    };

    const latestVoucher = getLastActivatedVoucher(offerCardData);

    const calculateExpired = (item) => {
        if (!item || !item.activatedDate || !item.expiryDate) return "00:00 min";

        const startTime = new Date(item.activatedDate).getTime();
        const endTime = new Date(item.expiryDate).getTime();

        if (isNaN(startTime) || isNaN(endTime)) return "00:00 min";

        const durationInSeconds = Math.max((endTime - startTime) / 1000, 0);

        const minutes = Math.floor(durationInSeconds / 60);
        const seconds = Math.floor(durationInSeconds % 60);

        return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")} min`;
    };

    const timeRemaining = (item) => {
        const diff = new Date(item.expiryDate).getTime() - Date.now();
        if (diff <= 0) return "Expired";

        const minutes = String(Math.floor(diff / (1000 * 60))).padStart(2, '0');
        const seconds = String(Math.floor((diff % (1000 * 60)) / 1000)).padStart(2, '0');

        return `${minutes}:${seconds} mins left`;
    };

    const isRed = (item) => {
        const expiry = new Date(item.expiryDate).getTime();
        const now = Date.now();
        const diffInSeconds = Math.max(0, Math.floor((expiry - now) / 1000));
        return diffInSeconds <= redTimer;
    };

    const handleSlideChange = (index) => {
        setActiveSlide(index);
        setShowFullPageQR(true);
    };

    useEffect(() => {
        if (sliderRef.current) {
            sliderRef.current.slickGoTo(activeSlide);
        }
    }, [activeSlide]);

    // useEffect(() => {
    //     if (!offerCardData?.length || !redeemActivated?.length) return;

    //     const currentItem = offerCardData[activeSlide];

    //     const redeemedMatch = redeemActivated.find(
    //         (r) => r.voucherNo === currentItem?.voucherNo && r.voucherStatus === "Redeemed"
    //     );

    //     const allRedeemed = offerCardData.every((item) =>
    //         redeemActivated.some(
    //             (r) => r.voucherNo === item.voucherNo && r.voucherStatus === "Redeemed"
    //         )
    //     );

    //     // Navigate when all vouchers are redeemed
    //     if (allRedeemed) {
    //         setTimeout(() => {
    //             navigate("/food-Vouchers-at-boxoffice");
    //         }, 2000);
    //         return; // Stop further processing
    //     }

    //     if (!redeemedMatch || isManualSlideRef.current) return;

    //     const timer = setTimeout(() => {
    //         const notRedeemed = (item) =>
    //             !redeemActivated.find(
    //                 (r) =>
    //                     r.voucherNo === item.voucherNo &&
    //                     r.voucherStatus === "Redeemed"
    //             );

    //         let nextIndex = null;

    //         // First look forward
    //         for (let i = activeSlide + 1; i < offerCardData.length; i++) {
    //             if (notRedeemed(offerCardData[i])) {
    //                 nextIndex = i;
    //                 break;
    //             }
    //         }

    //         // Then look backward
    //         if (nextIndex === null) {
    //             for (let i = activeSlide - 1; i >= 0; i--) {
    //                 if (notRedeemed(offerCardData[i])) {
    //                     nextIndex = i;
    //                     break;
    //                 }
    //             }
    //         }

    //         if (nextIndex !== null) {
    //             sliderRef.current?.slickGoTo(nextIndex);
    //         }
    //     }, 500);

    //     return () => clearTimeout(timer);
    // }, [activeSlide, offerCardData, redeemActivated, navigate]);

    const goToNextUnredeemedSlide = () => {
        const notRedeemed = (item) =>
            !redeemActivated?.find(
                (r) =>
                    r.voucherNo === item.voucherNo &&
                    r.voucherStatus === "Redeemed"
            );

        let nextIndex = null;

        for (let i = activeSlide + 1; i < offerCardData?.length; i++) {
            if (notRedeemed(offerCardData[i])) {
                nextIndex = i;
                break;
            }
        }

        if (nextIndex === null) {
            for (let i = activeSlide - 1; i >= 0; i--) {
                if (notRedeemed(offerCardData[i])) {
                    nextIndex = i;
                    break;
                }
            }
        }

        if (nextIndex !== null) {
            sliderRef.current?.slickGoTo(nextIndex);
        }
    };

    useEffect(() => {
        if (!showRedeem && !isClosingRedeem) {
            goToNextUnredeemedSlide();
        }
    }, [showRedeem, isClosingRedeem]);

    useEffect(() => {
        if (!redeemActivated?.length) return;

        redeemActivated.forEach((item) => {
            if (item.voucherStatus === "Redeemed" && !redeemTimestamps[item.voucherNo]) {
                setRedeemTimestamps((prev) => ({
                    ...prev,
                    [item.voucherNo]: new Date().toISOString()
                }));
            }
        });
    }, [redeemActivated]);

    const handleBack = () => {
        if (showFullPageQR && qrFilterlength > 1) {
            setShowFullPageQR(false);
        } else {
            const bckUrl = pageName === "FBOptionPage" ? "/?tab=food" : pageName === "offercart" ? "/foodcart" : "/food-Vouchers-at-boxoffice";
            navigate(bckUrl);
        }
    };

    return (
        <>
            <FbHeader className="offerNav" headname="Offer Activated" addressShow={pageName === "FBOptionPage" && !showFullPageQR ? false : true} locationName={offerCardData?.[activeSlide]?.theatreName} onBack={handleBack} filteredLength={qrFilterlength} />
            {loading ? (
                <OfferactivatedSkeleton />
            ) : (
                <div className='OfferActivatedAll contentPage*'>

                    {!showFullPageQR ?
                        (<section className='foodCard' style={{ padding: '0 15px' }}>
                            {offerCardData?.length > 0 && offerCardData?.map((item, index) => {
                                const activatedTime = item.activatedDate ? new Date(item.activatedDate).getTime() : 0;
                                const expiryTime = item.expiryDate ? new Date(item.expiryDate).getTime() : 0;
                                const diffInSeconds = expiryTime && activatedTime ? Math.floor((expiryTime - activatedTime) / 1000) : 0;
                                const formattedDate = Math.floor(diffInSeconds / 60);
                                const redeemedMatch = redeemActivated?.find(
                                    (redeemedItem) => redeemedItem.voucherNo === item.voucherNo && redeemedItem.voucherStatus === "Redeemed"
                                );
                                // const formattedDate = item.expiryDate ? new Date(item.expiryDate).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }) : "No Expiry";
                                return (
                                    <Fragment key={`${item.voucherNo}`}>
                                        <div className="foodCardinr" onClick={() => { handleSlideChange(index) }}>
                                            <div className="foodCardli">
                                                {redeemedMatch && (
                                                    <p className="redeemedTag m-0"><img src={redeemedIcon} alt="" /></p>
                                                )}
                                                <div className="qrcodevhr">
                                                    <QRCode className='qrcodesvg'
                                                        title="PVRINOX"
                                                        value={item?.voucherNo ? item?.voucherNo : "INVALID_CODE"}
                                                        bgColor="#FFFFFF"
                                                        fgColor="#000000"
                                                        size={100}
                                                    />
                                                </div>
                                                <div className="foodDisc">
                                                    <h4>{item?.voucherDesc}</h4>
                                                    <p className={`expiredFnt ${isRed(item) ? "red-timer" : "green-timer"}`} style={{ textAlign: "left" }}>
                                                        {timeRemaining(item)}
                                                    </p>
                                                    {/* <p className='expiredFnt'>Expired after {formattedDate}-minutes of activation.</p> */}
                                                    {/* <p>{timeRemaining(item)}</p> */}
                                                    {/* <p>Valid till {formattedDate}</p> */}
                                                </div>
                                            </div>
                                        </div>
                                    </Fragment>
                                )
                            })}
                        </section>)
                        :
                        (<section className='offerActivated offeractall'>
                            <Slider ref={sliderRef} {...settings} initialSlide={activeSlide}>
                                {offerCardData?.length > 0 && offerCardData?.map((item, index, filteredArray) => {
                                    const activatedTime = new Date(item.activatedDate).getTime();
                                    const expiryTime = new Date(item.expiryDate).getTime();
                                    const diffInSeconds = Math.floor((expiryTime - activatedTime) / 1000);
                                    const formattedDate = Math.floor(diffInSeconds / 60);

                                    const redeemedMatch = redeemActivated?.find(
                                        (redeemedItem) => redeemedItem.voucherNo === item.voucherNo && redeemedItem.voucherStatus === "Redeemed"
                                    );

                                    if (redeemedMatch && index === activeSlide && !isManualSlideRef.current) {
                                        setTimeout(() => {
                                            const isLast = index === filteredArray.length - 1;
                                            const isFirst = index === 0;
                                            if (!isLast) {
                                                sliderRef.current?.slickNext();
                                            } else if (!isFirst) {
                                                sliderRef.current?.slickPrev();
                                            }

                                            // setWasManuallyMoved(false); // reset
                                        }, 500);
                                    }

                                    // const formattedDate = formatDateWithOrdinal(item.expiryDate, true); redeem next prev work only on api hit not in scroll issue is when im scrolling its slider to next redeeem
                                    return (
                                        <div className='pb100'>
                                            <div className='qrcodeDetails'>
                                                <div className="qrcodecpn">
                                                    {filteredArray.length > 1 && <p className="tagCount" style={{ borderRadius: "0 12px" }}>{`${index + 1}/${filteredArray.length}`}</p>}
                                                    {redeemedMatch && (
                                                        <p className="redeemedTag m-0"><img src={redeemedIcon} alt="" /></p>
                                                    )}
                                                    <div className="qrcode">
                                                        <QRCode
                                                            title={item.voucherNo}
                                                            value={item.voucherNo ? item.voucherNo : "INVALID_CODE"}
                                                            bgColor="#FFFFFF"
                                                            fgColor="#000000"
                                                            size={200}
                                                        />
                                                    </div>
                                                    <p className='txtdsc'>Show QR at F&B Counter to redeem.</p>
                                                    <p className='cpncode'>{item.voucherNo}</p>
                                                </div>
                                                <div className="qrTitle">
                                                    <h4>{item.voucherDesc}</h4>
                                                    <p className={`expiredFnt ${redeemedMatch && "green-timer"}`}>
                                                        {redeemedMatch
                                                            ? `Redeemed at ${redeemTimestamps[item.voucherNo]
                                                                ? format(new Date(redeemTimestamps[item.voucherNo]), "hh:mm a")
                                                                : ""}`
                                                            : `Expires after ${formattedDate}-minutes of activation.`}
                                                    </p>
                                                </div>
                                            </div>
                                            <hr className='hrline' />
                                            <div className="offerterms">
                                                <h4>Rules</h4>
                                                {offerCardData.find(item => item.voucherNo === item.voucherNo)?.rules?.slice(1)?.map(rule => (
                                                    <div className="rlsflx">
                                                        <span>{rule?.description}</span>
                                                    </div>
                                                ))}
                                                {/* <div className="rlsflx">
                                                    <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M9 0.875C4.52 0.875 0.875 4.52 0.875 9C0.875 13.48 4.52 17.125 9 17.125C13.48 17.125 17.125 13.48 17.125 9C17.125 4.52 13.48 0.875 9 0.875ZM4.72917 14.3775C5.69167 12.9808 7.28167 12.125 9 12.125C10.7183 12.125 12.3083 12.9808 13.2708 14.3775C12.0967 15.3117 10.6142 15.875 9 15.875C7.38583 15.875 5.90333 15.3125 4.72917 14.3775ZM6.29167 8.16667C6.29167 6.67333 7.50667 5.45833 9 5.45833C10.4933 5.45833 11.7083 6.67333 11.7083 8.16667C11.7083 9.66 10.4933 10.875 9 10.875C7.50667 10.875 6.29167 9.66 6.29167 8.16667ZM14.175 13.5108C13.4483 12.5275 12.475 11.77 11.3542 11.33C12.3217 10.6075 12.9583 9.46417 12.9583 8.16667C12.9583 5.98417 11.1825 4.20833 9 4.20833C6.8175 4.20833 5.04167 5.98417 5.04167 8.16667C5.04167 9.46417 5.6775 10.6075 6.64583 11.33C5.525 11.7708 4.55167 12.5283 3.825 13.5108C2.77 12.3017 2.125 10.7267 2.125 9C2.125 5.20917 5.20917 2.125 9 2.125C12.7908 2.125 15.875 5.20917 15.875 9C15.875 10.7267 15.23 12.3025 14.175 13.5108Z" fill="black" />
                                                    </svg>
                                                    <span>Only once per user</span>
                                                </div>
                                                <div className="rlsflx">
                                                    <svg width="20" height="20" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M9.66667 0.833252H6.33333C5.875 0.833252 5.5 1.20825 5.5 1.66659C5.5 2.12492 5.875 2.49992 6.33333 2.49992H9.66667C10.125 2.49992 10.5 2.12492 10.5 1.66659C10.5 1.20825 10.125 0.833252 9.66667 0.833252ZM8 11.6666C8.45833 11.6666 8.83333 11.2916 8.83333 10.8333V7.49992C8.83333 7.04158 8.45833 6.66658 8 6.66658C7.54167 6.66658 7.16667 7.04158 7.16667 7.49992V10.8333C7.16667 11.2916 7.54167 11.6666 8 11.6666ZM13.8583 6.15825L14.4833 5.53325C14.8 5.21659 14.8083 4.69159 14.4833 4.36659L14.475 4.35825C14.15 4.03325 13.6333 4.04159 13.3083 4.35825L12.6833 4.98325C11.3917 3.94992 9.76667 3.33325 8 3.33325C4 3.33325 0.6 6.63325 0.5 10.6333C0.391666 14.8666 3.78333 18.3333 8 18.3333C12.15 18.3333 15.5 14.9749 15.5 10.8333C15.5 9.06659 14.8833 7.44159 13.8583 6.15825ZM8 16.6666C4.775 16.6666 2.16667 14.0583 2.16667 10.8333C2.16667 7.60825 4.775 4.99992 8 4.99992C11.225 4.99992 13.8333 7.60825 13.8333 10.8333C13.8333 14.0583 11.225 16.6666 8 16.6666Z" fill="black" />
                                                    </svg>
                                                    <span>11:00 AM - 11:00 PM</span>
                                                </div> */}
                                            </div>
                                            <div className="offerterms">
                                                <div className="rlsMain">
                                                    <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M8.99996 17.3334C4.39746 17.3334 0.666626 13.6026 0.666626 9.00008C0.666626 4.39758 4.39746 0.666748 8.99996 0.666748C13.6025 0.666748 17.3333 4.39758 17.3333 9.00008C17.3333 13.6026 13.6025 17.3334 8.99996 17.3334ZM8.99996 15.6667C10.7681 15.6667 12.4638 14.9644 13.714 13.7141C14.9642 12.4639 15.6666 10.7682 15.6666 9.00008C15.6666 7.23197 14.9642 5.53628 13.714 4.28604C12.4638 3.03579 10.7681 2.33341 8.99996 2.33341C7.23185 2.33341 5.53616 3.03579 4.28591 4.28604C3.03567 5.53628 2.33329 7.23197 2.33329 9.00008C2.33329 10.7682 3.03567 12.4639 4.28591 13.7141C5.53616 14.9644 7.23185 15.6667 8.99996 15.6667ZM8.16663 11.5001H9.83329V13.1667H8.16663V11.5001ZM9.83329 10.1292V10.6667H8.16663V9.41675C8.16663 9.19573 8.25442 8.98377 8.4107 8.82749C8.56698 8.67121 8.77895 8.58342 8.99996 8.58342C9.23669 8.5834 9.46855 8.51616 9.66856 8.38952C9.86858 8.26288 10.0285 8.08205 10.1298 7.86807C10.231 7.65408 10.2694 7.41574 10.2405 7.18078C10.2116 6.94582 10.1166 6.7239 9.96649 6.54084C9.81639 6.35778 9.61739 6.22111 9.39264 6.14672C9.1679 6.07234 8.92666 6.0633 8.69698 6.12067C8.4673 6.17803 8.25864 6.29944 8.09527 6.47076C7.93189 6.64208 7.82053 6.85628 7.77413 7.08842L6.13913 6.76091C6.24049 6.25432 6.47455 5.78372 6.81739 5.39724C7.16024 5.01075 7.59956 4.72223 8.09045 4.56118C8.58134 4.40013 9.1062 4.37232 9.61136 4.48059C10.1165 4.58887 10.5839 4.82934 10.9656 5.17744C11.3474 5.52553 11.6299 5.96875 11.7842 6.4618C11.9385 6.95485 11.9592 7.48004 11.844 7.98367C11.7288 8.48731 11.482 8.95133 11.1287 9.3283C10.7754 9.70527 10.3284 9.98167 9.83329 10.1292Z" fill="black" />
                                                    </svg>
                                                    <div className="inrdev">
                                                        <h4 onClick={() => {
                                                            handleTnC(item?.voucherNo, "howtowork");
                                                        }} style={{ textDecoration: "underline" }}>How it Works?</h4>
                                                        <p>Know how to avail this offer</p>
                                                    </div>
                                                </div>
                                                <div className="rlsflx hwIcon">
                                                    <div className="hwInnr">
                                                        <div className="rlsImg">
                                                            <img src={theme === "inoxTheme" ? chooseYourOfferInox : chooseYourOfferPvr} width={50} height={50} alt="Choose your offer" />
                                                        </div>
                                                        <p>Select Offer</p>
                                                    </div>
                                                    <div className="hwInnr">
                                                        <div className="rlsImg">
                                                            <img src={theme === "inoxTheme" ? activateOfferToSeeQrInox : activateOfferToSeeQrPvr} width={50} height={50} alt="Activate offer to see QR" />
                                                        </div>
                                                        <p>Activate Offer</p>
                                                    </div>
                                                    <div className="hwInnr">
                                                        <div className="rlsImg">
                                                            <img src={theme === "inoxTheme" ? howQrCodeInox : howQrCodePvr} width={50} height={50} alt="Show QR at cinemas F&B counter to redeem within 15-minutes" />
                                                        </div>
                                                        <p>Redeem at cinema counter</p>
                                                    </div>
                                                </div>
                                                {/* <div className="rlsflx hwIcon">
                                                    <div className="rlsImg">
                                                        <img src={theme === "inoxTheme" ? activateOfferToSeeQrInox : activateOfferToSeeQrPvr} alt="Activate offer to see QR" />
                                                    </div>
                                                    <span>Activate offer to see QR</span>
                                                </div>
                                                <div className="rlsflx hwIcon">
                                                    <div className="rlsImg">
                                                        <img src={theme === "inoxTheme" ? howQrCodeInox : howQrCodePvr} alt="Show QR at cinemas F&B counter to redeem within 15-minutes" />
                                                    </div>
                                                    <span>Show QR at cinema F&B counter to place order.</span>
                                                </div> */}
                                            </div>

                                            {item?.termCondition?.length > 0 && <p className="tncdetal" onClick={() => handleTnC(item?.voucherNo)} style={{ padding: 15 }}>Terms & Conditions</p>}
                                        </div>
                                    )
                                })}
                            </Slider>
                        </section>)
                    }
                    {showFullPageQR && !redeemActivated?.some(redeemed => redeemed.voucherNo === offerCardData?.[activeSlide]?.voucherNo && redeemed.voucherStatus === "Redeemed") &&
                        <section className='offerTimer ofractv' style={{ width: "calc(100%)" }}>
                            <CountdownTimer className="offerTimerSet" timerId={offerCardData?.[activeSlide]?.voucherNo} duration={calculateDuration(offerCardData?.[activeSlide])} count={false} title="Offer expires in" />
                        </section>
                    }
                </div>
            )}
            <Modal className='fullPageModal tncModal'
                show={showRedeem || isClosingRedeem}
                onHide={handleHideRedeem}
                animation={false}
                keyboard={false}
                dialogClassName={isClosingRedeem ? "modal-dialog modal-hide" : "modal-dialog"}
                style={{ backgroundColor: "rgba(0,0,0,0.7)", overflow: "hidden" }}
            >
                {/* <div className="tnchdr">
                    <span className="Cus-itemspan">Success</span>
                    <img
                        style={{ cursor: "pointer" }}
                        onClick={handleHideRedeem}
                        src={closeIcon}
                        alt="close"
                    />
                </div> */}

                <img
                    src={redeemedSucess}
                    width={400}
                    height={400}
                    className='redemgif'
                    alt="redeemedSucess"
                />
                <h4 className='hdrTitle'>Success</h4>
                <p className='hdrdesc'>Yahoo! Voucher redeemed!</p>
                <p className="rdcthdr">Redirecting in {count}...</p>
            </Modal>

            <Modal className='slideTopModal tncModal'
                show={showHowItsWork || isClosingHowItsWork}
                onHide={handleHideHowItsWork}
                animation={false}
                keyboard={false}
                dialogClassName={isClosingTnC ? "modal-dialog modal-hide" : "modal-dialog"}
                style={{ backgroundColor: "rgba(0,0,0,0.7)", overflow: "hidden" }}
            >
                <div className="tnchdr">
                    <div></div>
                    <span className="Cus-itemspan">{tncData?.howToAvail?.[0]?.description}</span>
                    <img
                        style={{ cursor: "pointer" }}
                        onClick={handleHideHowItsWork}
                        src={closeIcon}
                        alt="close"
                    />
                </div>
                <ul className='termsul'>
                    {tncData?.howToAvail?.slice(1).map((item) => (
                        <li>{item?.description}</li>
                    ))}
                </ul>
                <button className='fb-added-btn' onClick={handleHideHowItsWork} style={{ width: "100%" }}>Ok</button>
            </Modal>
            <Modal className='slideTopModal tncModal'
                show={showTnC || isClosingTnC}
                onHide={handleHideTnC}
                animation={false}
                keyboard={false}
                dialogClassName={isClosingTnC ? "modal-dialog modal-hide" : "modal-dialog"}
                style={{ backgroundColor: "rgba(0,0,0,0.7)", overflow: "hidden" }}
            >
                <div className="tnchdr">
                    <div></div>
                    <span className="Cus-itemspan">Terms & conditions</span>
                    <img
                        style={{ cursor: "pointer" }}
                        onClick={handleHideTnC}
                        src={closeIcon}
                        alt="close"
                    />
                </div>
                <ul className='termsul'>
                    {tncData?.termCondition?.map((terms) => (
                        <li>{terms.replace("•\t", "")}</li>
                    ))}
                </ul>
                <button className='fb-added-btn' onClick={handleHideTnC} style={{ width: "100%" }}>Accept</button>
            </Modal>

            {/* <Modal className='centerModal'
                show={showTimer || isClosingTimer}
                onHide={handleHide}
                animation={false}
                keyboard={false}
                dialogClassName={isClosingTimer ? "modal-dialog modal-hide" : "modal-dialog"}
                style={{ backgroundColor: "rgba(0,0,0,0.7)", overflow: "hidden" }}
            >
                <div className="modalbody">
                    <svg className='modaltimerIcon' width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 0.666992H6V2.00033H10V0.666992ZM7.33333 9.33366H8.66667V5.33366H7.33333V9.33366ZM12.6867 4.92699L13.6333 3.98033C13.3467 3.64033 13.0333 3.32033 12.6933 3.04033L11.7467 3.98699C10.7133 3.16033 9.41333 2.66699 8 2.66699C4.68667 2.66699 2 5.35366 2 8.66699C2 11.9803 4.68 14.667 8 14.667C11.32 14.667 14 11.9803 14 8.66699C14 7.25366 13.5067 5.95366 12.6867 4.92699ZM8 13.3337C5.42 13.3337 3.33333 11.247 3.33333 8.66699C3.33333 6.08699 5.42 4.00033 8 4.00033C10.58 4.00033 12.6667 6.08699 12.6667 8.66699C12.6667 11.247 10.58 13.3337 8 13.3337Z" fill="black" />
                    </svg>
                    <h3>Oops! Offer Time Expired</h3>
                    <p>Unfortunately, your offer time has expired. Please go to the offers page to activate it again</p>
                    <button className='modalbtn dismissbtn' onClick={handleDismiss}>Dismiss</button>
                </div>
            </Modal> */}

            <SweetAlertUtility
                type={alertDetails.type}
                title={alertDetails.title}
                message={alertDetails.message}
                show={alertDetails.show}
                onConfirm={hideAlert}
            />
        </>
    )
}

export default OfferActivated
